import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import MonacoCard from '../MonacoTheme/MonacoCard';
import {
	getCurrencySymbol,
	loadStateSession,
	saveStateSession,
} from '../../../FlyfishComponents/flyfishutils/utils';
import Axios from 'axios';
import Modal from '../../../FlyfishComponents/Modal';
import EcomChatModal from './EcomChatModal';

const EcomChatModalContent = styled.div`
	> .modal-container-bot {
		& > .body1 {
			height: 100%;
		}
	}
	.ecom-modal-container {
		height: calc(100vh - 19px);
		padding: 0px;
	}
`;
const EcomChatDiv = styled.div`
	display: flex;
	justify-content: center;
	margin-top: 20px;
	& > .product-list {
		& > .category {
			display: flex;
			justify-content: center;
			margin: 20px 0;
			& > p {
				font-size: 16px;
				color: #080758;
				text-transform: uppercase;
				letter-spacing: 0.8px;
				font-family: Montserrat;
			}
		}
		& > .product-row {
			display: flex;
			gap: 10px;
			margin-bottom: 20px;
			& > .product {
				&.selected {
					border: 1px solid #585454;
				}
			}
		}
		& > .view-products {
			display: flex;
			align-items: center;
			justify-content: center;
			gap: 16px;
			& > .show-more,
			& > .show-less {
				font-size: 12px;
				color: #020202;
				font-family: Montserrat !important;
				display: flex;
				justify-content: center;
				align-items: center;
				gap: 10px;
				& > p {
					cursor: pointer;
					width: fit-content;
				}
				color: ${(props) =>
		props.colorMode === 'dark'
			? 'var(--colorScale-3)'
			: 'var(--colorScale-0)'};
				& > svg {
					position: relative;
					top: 1px;
					stroke: ${(props) =>
		props.colorMode === 'dark'
			? 'var(--colorScale-3)'
			: 'var(--colorScale-0)'};
				}
			}
		}
	}
`;

const EcomChatTheme = (props: any) => {
	const [monacoProducts, setMonacoProducts] = useState(
		props.metaData.products || []
	);
	const [monacoCategories, setMonacoCategories] = useState(
		props.metaData.categories || []
	);
	const [visibleRows, setVisibleRows] = useState(1);

	const [productsPerRow, setProductsPerRow] = useState(4);
	const [llmproducts, setLLMProducts] = useState([]);

	const [selectedProduct, setSelectedProduct] = useState(null);
	const [productModal, setProductModal] = useState(false);
	const [category, setCategory] = useState('');
	const [categoriesArray, setCategoriesArray] = useState<any>([
		{
			category: props.metaData.categories[0],
			products: props.metaData.products,
			rows: 1,
		},
	]);
	const [categoriesLLMArray, setCategoriesLLMArray] = useState<any>([]);
	const [quantityUpdated, setQuantityUpdated] = useState(false);
	const [update, setUpdate] = useState(false);
	const [reasonData, setReasonData] = useState<any>('');
	const [reasonQuery, setReasonQuery] = useState<any>('');
	const [selectedProductID, setSelectedProductID] = useState(null);
	const [styleAdvisorCache, setStyleAdvisorCache] = useState<any>([]);
	const [productIds, setProductIds] = useState([]);
	const [cacheShopPriceResp, setCacheShopPriceResp] = useState<any>({});

	useEffect(() => {
		let width = window.innerWidth;
		if (width > 600 && width < 800) {
			setProductsPerRow(3);
		} else if (width <= 800) {
			setProductsPerRow(2);
		} else if (width > 800 && width < 1366) {
			setProductsPerRow(3);
		} else {
			setProductsPerRow(4);
		}
	}, [window.innerWidth]);
	const filterProduct = (products) => {
		let productIdsArray;
		categoriesArray.map((category, categoryIndex) => {
			if (category.products.length > 0) {
				productIdsArray =
					category &&
					category.products &&
					category.products.map((eachItem) => {
						return eachItem.product_id;
					});
			}
		});
		setProductIds(productIdsArray);
		const filteredProducts = products.filter(
			(product) => !productIdsArray.includes(product.product_id)
		);
		return filteredProducts;
	};
	useEffect(() => {
		let array = [];
		monacoCategories.map((category, categoryIndex) => {
			if (categoryIndex !== 0) {
				// let payload = {
				// 	input_text: props.userQuery,
				// 	bot_id: loadStateSession('botID'),
				// 	tenant_id: props.tenantId,
				// 	version: 'prod',
				// 	conversationId: props.conversationId,
				// 	category: category,
				// 	messageId: loadStateSession('messageId'),
				// 	source: 'web',
				// };

				Axios.get(
					`${window['BASE_URL']}/conversation/tenant/${props.tenantId
					}/bot/${loadStateSession(
						'botID'
					)}/complementary_products?input_text=${props.userQuery
					}&conversation_id=${props.conversationId
					}&message_id=${loadStateSession('messageId')}`,
					{
						headers: {
							'Authorization': `Bearer ${loadStateSession('token')}`,
							'x-tenant-id': loadStateSession('tenantId') || loadStateSession('tenantID')
						}
					}
				).then((resp: any) => {
					let categoryWithResp = {
						category: category,
						products: filterProduct(resp.data),
						rows: 1,
					};
					array.push(categoryWithResp);

					if (categoryIndex === monacoCategories.length - 1) {
						let finalArray = [
							{
								category: monacoCategories[0],
								products: monacoProducts,
								rows:
									loadStateSession(`FF-topProducts-counter-${props.index}`) ??
									1,
							},
							...array,
						];

						setCategoriesArray(finalArray);
					}
				});
			}
		});
	}, [update]);

	useEffect(() => {
		if (categoriesArray.length && !quantityUpdated) {
			let array = [];
			categoriesArray.map((category, categoryIndex) => {
				if (
					category.products.length > 0 &&
					!cacheShopPriceResp[category.category]
				) {
					let productIdsArray =
						category &&
						category.products &&
						category.products.map((eachItem) => {
							return eachItem.product_id || eachItem.productId;
						});
					setProductIds(productIdsArray);
					let stringifyProductIDs = String(productIdsArray);

					stringifyProductIDs &&
						stringifyProductIDs !== 'undefined' &&
						stringifyProductIDs !== 'false' &&
						Axios.get(
							`${window['BASE_URL']}/shop/${props.tenantId
							}/products/price?productIds=${stringifyProductIDs}&country=${loadStateSession(
								'FS-countryCode'
							)}`,
							{
								headers: {
									'x-tenant-id': props.tenantId,
									Authorization: `Bearer ${props.token}`,
								},
							}
						).then((resp: any) => {
							let response = resp.data.response;
							let products = response.data.products;
							let categoryWithResp = {
								category: category.category,
								products: products,
								rows: 1,
							};

							array.push(categoryWithResp);
							setCacheShopPriceResp((prev) => ({
								...prev,
								[category.category]: categoryWithResp,
							}));

							if (categoryIndex === categoriesArray.length - 1) {
								let finalArray = [...array];
								setCategoriesLLMArray(finalArray);
							}
						});
				}
			});
		}
	}, [categoriesArray]);
	useEffect(() => {
		//handleProductDetails();
	}, []);
	const showMore = (category, index) => {
		setQuantityUpdated(true);
		saveStateSession(
			`FF-topProducts-counter-${index}`,
			Number(loadStateSession(`FF-topProducts-counter-${index}`)) + 1
		);
		setCategoriesArray((prevCategoriesArray) => {
			return prevCategoriesArray.map((item) => {
				if (item.category === category) {
					return { ...item, rows: item.rows + 1 }; // Update rows for the matching category
				}
				return item;
			});
		});
	};
	const showLess = (category, index) => {
		setQuantityUpdated(true);
		saveStateSession(
			`FF-topProducts-counter-${index}`,
			Number(loadStateSession(`FF-topProducts-counter-${index}`)) - 1
		);
		setCategoriesArray((prevCategoriesArray) => {
			return prevCategoriesArray.map((item) => {
				if (item.category === category) {
					return { ...item, rows: item.rows - 1 }; // Update rows for the matching category
				}
				return item;
			});
		});
	};
	const displaySymbol = (currencyCode) => {
		return getCurrencySymbol(currencyCode);
	};
	useEffect(() => { }, [visibleRows]);

	const productSelection = (product) => {
		setSelectedProduct(
			product.product_id === selectedProduct ? null : product.product_id
		);
		props.handleSelectedProduct({
			productID: product.product_id,
			productName: product.title,
		});
		saveStateSession('FF-productID', product.product_id);
		setProductModal(true);
		setSelectedProductID(product.product_id);
	};

	const styleSelection = (product) => {
		setSelectedProduct(
			product.product_id === selectedProduct ? null : product.product_id
		);
		props.handleSelectedProduct({
			productID: product.product_id,
			productName: product.title,
		});
		saveStateSession('FF-productID', product.productId);
		setProductModal(true);
		setSelectedProductID(product.productId);
	};
	const handleProductDetails = (productId) => {
		// if (props.metaData.get_products === 'true') {
		// let topProductData = props.metaData.products.filter(
		// 	(item) => (item.product_id || item.productId) === productId
		// )[0].reason_query
		// console.log(topProductData)
		Axios.get(
			window['BASE_URL'] +
			`/conversation/tenant/${props.tenantId}/bot/${props.productData.botId}/recommendation_rational?text=${props.productData.message}&conversation_id=${props.productData.id}&message_id=${props.productData.messageId}&productId=${productId}`,
			{
				headers: {
					'Authorization': `Bearer ${loadStateSession('token')}`,
					'x-tenant-id': loadStateSession('tenantId') || loadStateSession('tenantID')
				}
			}
		).then((response) => {
			setReasonData(response.data.products[0].reason);
			setReasonQuery('');
		});
		//}
	};
	const EcomProductList = (page: string = '') => {
		return (
			<>
				{monacoCategories &&
					monacoCategories.map((category, categoryIndex) => {
						let indexOfProduct = categoriesArray.findIndex((item) => {
							return item.category === category;
						});

						if (categoriesArray[indexOfProduct]) {
							return (
								<>
									{categoryIndex !== 0 && (
										<div className='category'>
											{categoriesArray[indexOfProduct] &&
												categoriesArray[indexOfProduct].products.length >= 1 ? (
												<p>{category}</p>
											) : null}
										</div>
									)}
									{Array.from(
										{
											length:
												category === categoriesArray[indexOfProduct].category
													? categoriesArray[indexOfProduct].rows
													: 1,
										},
										(_, rowIndex) => (
											<div className='product-row' key={rowIndex}>
												{categoriesArray[indexOfProduct] &&
													categoriesArray[indexOfProduct].products
														.filter((product) =>
															page === 'ecom cart'
																? categoryIndex !== 0 &&
																product.category === category
																: product.category === category
														)
														.slice(
															rowIndex * productsPerRow,
															(rowIndex + 1) * productsPerRow
														)
														.map((product, index) => {
															let llmMatchedProduct: any = [];
															let price = product.price;
															let currency = product.currency;
															let imageOnHover = product.media_link;
															let sale_price = product.sale_price;
															if (categoriesLLMArray.length) {
																llmMatchedProduct = categoriesLLMArray.length
																	? categoriesLLMArray[indexOfProduct] &&
																	categoriesLLMArray[
																		indexOfProduct
																	].products.filter(
																		(v) => v.id === product.product_id
																	)
																	: '';
																if (
																	llmMatchedProduct &&
																	llmMatchedProduct.length
																) {
																	price =
																		llmMatchedProduct &&
																		llmMatchedProduct[0].price;

																	currency =
																		llmMatchedProduct &&
																		llmMatchedProduct[0].currency;
																	imageOnHover = llmMatchedProduct[0].images
																		.length
																		? llmMatchedProduct[0].images[1]
																			? llmMatchedProduct[0].images[1] ===
																				product.media_link
																				? llmMatchedProduct[0].images[0]
																				: llmMatchedProduct[0].images[1]
																			: product.media_link
																		: product.media_link;
																	sale_price =
																		llmMatchedProduct &&
																		llmMatchedProduct[0].sale_price;
																}
															}

															return (
																<div
																	className={`product ${product.product_id === selectedProduct
																		? 'selected'
																		: ''
																		}`}
																	key={product.product_id}
																	onClick={() => {
																		productSelection(product);
																		setCategory(product.category);
																		handleProductDetails(product.product_id);
																	}}
																>
																	<MonacoCard
																		selectedProduct={
																			product.product_id === selectedProduct
																		}
																		key={product.product_id + '-card'}
																		title={product.title}
																		price={price}
																		sale_price={sale_price}
																		currency={displaySymbol(currency)}
																		header={product.header}
																		mediaType={product.media_type}
																		mediaLink={product.media_link}
																		imageOnHover={imageOnHover}
																	/>
																</div>
															);
														})}
											</div>
										)
									)}
									{page !== 'ecom cart' && categoryIndex === 0 ? (
										<div className='view-products'>
											{(category === categoriesArray[indexOfProduct].category
												? categoriesArray[indexOfProduct].rows
												: 1) *
												productsPerRow <
												(categoriesArray &&
													categoriesArray[indexOfProduct] &&
													categoriesArray[indexOfProduct].products.filter(
														(product) => product.category === category
													).length) && (
													<div
														className='show-more'
														onClick={() => showMore(category, props.index)}
													>
														<svg
															xmlns='http://www.w3.org/2000/svg'
															width='11.478'
															height='7.153'
															viewBox='0 0 11.478 7.153'
														>
															<path
																id='Path_20566'
																data-name='Path 20566'
																d='M15425.4,681.9l5.032,5.032,5.031-5.032'
																transform='translate(-15424.696 -681.194)'
																fill='none'
																stroke-width='2'
															/>
														</svg>
														<p>View More</p>
													</div>
												)}
											{categoriesArray[indexOfProduct] &&
												categoriesArray[indexOfProduct].rows > 1 && (
													<div
														className='show-less'
														onClick={() => showLess(category, props.index)}
													>
														<svg
															xmlns='http://www.w3.org/2000/svg'
															width='11.478'
															height='7.153'
															viewBox='0 0 11.478 7.153'
														>
															<path
																id='Path_20566'
																data-name='Path 20566'
																d='M15425.4,686.933l5.032-5.032,5.031,5.032'
																transform='translate(-15424.696 -680.487)'
																fill='none'
																stroke-width='2'
															/>
														</svg>
														<p>View Less</p>
													</div>
												)}
										</div>
									) : null}
								</>
							);
						} else {
							null;
						}
					})}
			</>
		);
	};

	return (
		<>
			<EcomChatDiv className='ff-ecom-chat-theme'>
				<div className='product-list'>{EcomProductList()}</div>
			</EcomChatDiv>
			<EcomChatModalContent className='ff-ecom-chat-modal-content'>
				{productModal && (
					<Modal
						footerNotReq={true}
						onClose={() => setProductModal(false)}
						headerCloseBtn
						remove
						headerCloseBtnIcon={
							<svg
								xmlns='http://www.w3.org/2000/svg'
								width='29.255'
								height='29.25'
								viewBox='0 0 29.255 29.25'
							>
								<g
									id='Icon_ion-ios-close-outline'
									data-name='Icon ion-ios-close-outline'
									transform='translate(-3.372 -3.375)'
								>
									<path
										id='Path_20510'
										data-name='Path 20510'
										d='M28.343,7.657a14.627,14.627,0,1,0,0,20.686,14.632,14.632,0,0,0,0-20.686Zm-.865,19.821a13.4,13.4,0,1,1,0-18.956A13.423,13.423,0,0,1,27.478,27.478Z'
									/>
									<path
										id='Path_20511'
										data-name='Path 20511'
										d='M23.92,11.25l-5.934,5.92L12.08,11.278l-.83.83L17.156,18,11.25,23.892l.83.83,5.906-5.892,5.934,5.92.83-.83L18.816,18l5.934-5.92Z'
									/>
								</g>
							</svg>
						}
						actionButtons={<></>}
					>
						<EcomChatModal
							styleSelection={styleSelection}
							reasonData={reasonData}
							reasonQuery={reasonQuery}
							selectedProductID={selectedProductID}
							tenantId={props.tenantId}
							token={props.token}
							responseId={props.productData.id}
							botId={props.productData.botId}
							handleSelectedProduct={props.handleSelectedProduct}
							onClose={() => setProductModal(false)}
							setStyleAdvisorCache={(data) => setStyleAdvisorCache(data)}
							styleAdvisorCache={styleAdvisorCache}
							category={category}
							productIds={productIds}
							setCategory={(data) => setCategory(data)}
							conversationId={props.conversationId}
							messageId={loadStateSession('messageId')}
							advisorTitle={props.advisorTitle}
							enableStyleAdvisor={props.enableStyleAdvisor}
							staticDetailsURL={props.staticDetailsURL}
							userQuery={props.productData.message}
						/>
					</Modal>
				)}
			</EcomChatModalContent>
		</>
	);
};

export default EcomChatTheme;
